export default [
	{
        name: 'Article',
    },
    {
        name: 'Activity',
    },
    {
        name: 'Walkthrough',
    },
    {
        name: 'Rubric',
    },
]